import Request from "services";
import { Endpoints } from "services/endpoints";
import { handleRequestError } from "utils";
import {AddBizInfoRequest, BusinessAccountRequest, GetStartedRequest, ShareHolderRequest, StructureRequest, UploadOnboardingDocsRequest} from "./types";
import { OnboardingStatus } from "interface/onboardingStatus";

// onboardingInfo
// onboardingRegistration
// onboardingShareholder
// onboardingAccount

export const getOnboardingStatus = async () => {
  try {
    const response = await Request.getWithUserToken<OnboardingStatus>(
      Endpoints.onboardingStatus,
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const onboardingGetStarted = async (data?: GetStartedRequest) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingBegin,
      {
        data,
      }
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const addBusinessInfo = async (data: AddBizInfoRequest) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingInfo, {data: data}
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const uploadOnboardingDocs = async (data: UploadOnboardingDocsRequest) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingRegistration,
      {data}
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const addBusinessShareholderInfo = async (data: Partial<ShareHolderRequest>) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingShareholder, {data}
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};


export const businessStructure = async (data: StructureRequest) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingStructure, {data}
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
};

export const addBusinessBank = async (data: BusinessAccountRequest) => {
  try {
    const response = await Request.postWithUserToken(
      Endpoints.onboardingAccount, {data}
    );
    return response;
  } catch (error) {
    handleRequestError(error);
  }
}